import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useStickyPlayer } from "../../hooks/useStickyPlayer";
import { StickyVideoContext } from ".";

export const StickyVideoProvider = ({
  children,
  config = {},
  stickyPlayerContext
}) => {
  const {
    isStickyEnabled,
    isOpenSticky,
    playingId,
    openId,
    updateStickyContext,
    setOverrideStickyContext,
    setIsStickyEnabled
  } = useStickyPlayer(config, stickyPlayerContext);

  const contextValue = useMemo(
    () => ({
      isStickyEnabled,
      isOpenSticky,
      playingId,
      openId,
      updateStickyContext,
      setOverrideStickyContext,
      setIsStickyEnabled
    }),
    [
      isStickyEnabled,
      isOpenSticky,
      playingId,
      updateStickyContext,
      setOverrideStickyContext,
      openId,
      setIsStickyEnabled
    ]
  );

  return (
    <StickyVideoContext.Provider value={contextValue}>
      {children}
    </StickyVideoContext.Provider>
  );
};

StickyVideoProvider.propTypes = {
  config: PropTypes.object,
  children: PropTypes.node,
  stickyPlayerContext: PropTypes.object
};
